import React from "react";
import { useIntl } from "react-intl";
import type { FC } from "react";

import { SubscriptionsDialog } from "../SubscriptionsDialog";
import { IDeleteSubscriptionDialogProps } from "./DeleteSubscriptionDialog.types";
import messages from "./DeleteSubscriptionDialog.messages";

export const DeleteSubscriptionDialog: FC<IDeleteSubscriptionDialogProps> = (props) => {
  const { subscriptionItemName, onDelete, ...otherProps } = props;
  const { formatMessage } = useIntl();

  return (
    <SubscriptionsDialog
      title={messages.title}
      contentText={formatMessage(messages.contentText, { subscriptionItemName })}
      actions={[{ name: messages.remove, handleClick: onDelete }, { name: messages.cancel }]}
      alignActions="left"
      {...otherProps}
    />
  );
};
